import ButtonComponent from './ButtonComponent.vue'
import CampaignGrid from './CampaignGrid.vue'
import ParagraphComponent from './ParagraphComponent.vue'
import EmbedDocument from './EmbedDocument.vue'
import ModalComponent from './ModalComponent.vue'
import ReceiptExamples from './ReceiptExamples.vue'
import ReceiptInformation from './ReceiptInformation.vue'
import ReceiptProcessor from './ReceiptProcessor.vue'
import RetailerComponent from './RetailerComponent.vue'

export default [
  ButtonComponent,
  CampaignGrid,
  ParagraphComponent,
  EmbedDocument,
  ModalComponent,
  ReceiptExamples,
  ReceiptInformation,
  ReceiptProcessor,
  RetailerComponent
]
